import * as THREE from 'three';
import { sceneUnitsFromMm } from '../../utils/scaler';

// Small ring shown before the first click of the Circle tool, centered exactly on the cursor —
// signals "this click sets the center." Built in the XZ plane (default normal +Y), same convention
// as PlaneGridHelper's own decorative circle, so orienting it to a hovered surface normal is a
// single setFromUnitVectors() call.
export default class CircleHintHelper {
    #circle: THREE.LineLoop;

    constructor() {
        const radius = sceneUnitsFromMm(150);
        const segments = 48;
        const points: THREE.Vector3[] = [];
        for (let i = 0; i < segments; i++) {
            const angle = (i / segments) * Math.PI * 2;
            points.push(new THREE.Vector3(Math.cos(angle) * radius, 0, Math.sin(angle) * radius));
        }
        const geometry = new THREE.BufferGeometry().setFromPoints(points);
        const material = new THREE.LineBasicMaterial({ color: 0x00FF00 });
        this.#circle = new THREE.LineLoop(geometry, material);
        this.#circle.visible = false;
        this.#circle.name = "CircleHint";
    }

    addToScene(scene: THREE.Scene) {
        scene.add(this.#circle);
    }

    update(point: THREE.Vector3, normal: THREE.Vector3) {
        this.#circle.position.copy(point);
        const defaultNormal = new THREE.Vector3(0, 1, 0);
        this.#circle.quaternion.setFromUnitVectors(defaultNormal, normal);
    }

    show() {
        this.#circle.visible = true;
    }

    hide() {
        this.#circle.visible = false;
    }

    dispose() {
        if (this.#circle.parent) {
            this.#circle.parent.remove(this.#circle);
        }
        this.#circle.geometry.dispose();
        (this.#circle.material as THREE.Material).dispose();
    }
}
